import { render, staticRenderFns } from "./daisy-message-form-modal.component.vue?vue&type=template&id=1ac6cb3d&scoped=true&"
import script from "./daisy-message-form-modal.component.vue?vue&type=script&lang=ts&"
export * from "./daisy-message-form-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./daisy-message-form-modal.component.vue?vue&type=style&index=0&id=1ac6cb3d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac6cb3d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VCombobox,VForm,VRow,VSelect,VSwitch,VTextField,VTextarea})
